window.headerSearchAnalytics = (schoolType) => {
    if(!schoolType) return;
    let schoolTypeText = schoolType.trim();
    ga('send', 'event', {
        eventCategory: 'Header Search',
        eventAction: schoolTypeText,
        eventLabel: schoolTypeText
    });
}
